import * as React from 'react'
import { ErrorGroupState, ErrorStatusCode } from '../domain/Error'

interface Props {
    status: ErrorStatusCode
}
class ListStatusLabel extends React.Component<Props> {
    public render() {
        switch (this.props.status) {
            case ErrorGroupState.ALWAYS_IGNORED:
                return <small className="label pull-right label-default">Ignored</small>
            case ErrorGroupState.IGNORED:
                return <small className="label pull-right label-default">Ignored</small>
            case ErrorGroupState.RESOLVED:
                return <small className="label pull-right label-success">Resolved</small>
            default:
                return <small className="label pull-right label-danger">Open</small>
        }
    }
}

export default ListStatusLabel
